/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".error-holder[_ngcontent-%COMP%]{position:absolute;left:110px}.footer-title-holder[_ngcontent-%COMP%]{position:absolute;left:20px;white-space:nowrap!important;line-height:5px}"];
export { styles as styles };
